import React from 'react'
// libs
import styled, { css } from 'styled-components'
// components
import NodeContent from 'components/PageComponents/Plans/Edit/components/ObjectivesListPreview/ObjectivesTreeTheme/NodeContent'
import NodeContentBL from 'containers/ObjectivesList/components/NodeContent/layers/BL'
// constants
import { ENTITIES, NODE_CONTENT_RENDERER_SIZES } from 'constants/index'
// themes
import { colors } from 'themes'
// icons
import ArrowIconOrigin from '@mui/icons-material/ArrowForwardIos'
// views
import { ContentWrapper, IconsWrapper } from 'themes/views/objectivesList'
// utils
import get from 'lodash/get'
import { isColorLight } from 'utils/tree'
import { generateLogEntityType } from 'utils/activities'

// styled
const Wrapper = styled.div<{
  $isKPI: boolean
  $isAction: boolean
  $background?: string
}>`
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  height: ${NODE_CONTENT_RENDERER_SIZES.NODE_HEIGHT}px;

  ${({ $background }) => `background: ${$background}`};
  ${({ $background }) => isColorLight($background) && `border: 1px solid ${colors.gray290}`};
  ${({ $isAction, $isKPI }) => ($isAction || $isKPI) && `background: none;`};
`

const CollapseIcon = styled(ArrowIconOrigin)<{
  $hidden?: boolean
  $isExpanded: boolean
}>`
  && {
    visibility: ${({ $hidden }) => ($hidden ? 'hidden' : 'visible')};

    path {
      fill: 'white';
    }

    ${({ $isExpanded }) =>
      $isExpanded &&
      css`
        transform: rotate(90deg);
      `}
  }
`

const MinimalThemeNodeContentRenderer = (props) => {
  const { node, title, ...otherProps } = props

  const color = get(node, 'color')
  const nodeTitle = title || node.title
  const hasChildren = !!get(node, 'children.length')

  const isKPI = node.entityType === ENTITIES.PLAN_KPI
  const isAction = node.entityType === ENTITIES.PLAN_ACTION
  const isObjective = node.entityType === ENTITIES.PLAN_OBJECTIVE
  const isRootObjective = !node.parentId && node.entityType === ENTITIES.PLAN_OBJECTIVE

  if (node.isCreateRoot) {
    return null
  }

  return (
    <Wrapper $isKPI={isKPI} $isAction={isAction} $background={isRootObjective && color} {...otherProps}>
      <IconsWrapper
        $isKPI={isKPI}
        $background={color}
        $isAction={isAction}
        $isRoot={isRootObjective}
        $isObjective={isObjective}>
        {hasChildren && isObjective && <CollapseIcon $isExpanded={node.expanded} color={'inherit'} />}
      </IconsWrapper>
      <ContentWrapper
        $isKPI={isKPI}
        $background={color}
        $isAction={isAction}
        $isRoot={isRootObjective}
        $isObjective={isObjective}>
        <NodeContentBL node={node}>
          <NodeContent
            node={node}
            isKPI={isKPI}
            background={color}
            isAction={isAction}
            nodeTitle={nodeTitle}
            isRoot={isRootObjective}
            isObjective={isObjective}
            hasChildren={hasChildren}
            isRootObjective={isRootObjective}
            entity={{ id: node.entityId, entityType: generateLogEntityType(node.entityType) }}
          />
        </NodeContentBL>
      </ContentWrapper>
    </Wrapper>
  )
}

export default MinimalThemeNodeContentRenderer
